export const PATHS = {
    ROOT: 'irproducts',
    ONBOARDING: 'onboarding',
    FOREIGN: 'foreign',
}